import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import $ from "jquery";
import { SWAL_SETTINGS, showFilterlist } from "../../../../utils/Constants";
import {
  formateDateWithMonth,
  handleServerValidations,
} from "../../../../utils/commonfunction";
import StatusFilter from "../../common/statusFilter";
import CustomRangepicker from "../../common/rangepicker";
import {
  rewardConfigList,
  rewardConfigStatus,
  rewardConfigDelete,
} from "../../services/reward-config.services";

const RewardConfigTable = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({ order: -1, column: "createdAt" });
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const [resetdate, setResetDate] = useState(false);

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("Reward Management"), url: "" },
  ];

  useEffect(() => {
    const getData = setTimeout(() => {
      setLoader(true);
      const queryParams = {
        page: params.pgno || 1,
        per_page: itemperpage,
        sort: JSON.stringify(sorting),
        search: JSON.stringify(search),
        global_search: globalsearch,
      };
      rewardConfigList(queryParams)
        .then((data) => {
          setDataLength(data.data.total_records);
          setList(
            data && data.data && data.data.list && Array.isArray(data.data.list)
              ? data.data.list
              : [],
          );
          setPage(data && data.data && data.data.page ? data.data.page : 1);
          setLoader(false);
        })
        .catch((error) => {
          console.log("error ====> ", error);
          setLoader(false);
        });
    }, 300);
    return () => clearTimeout(getData);
  }, [
    location,
    statsupdate,
    sorting,
    search,
    globalsearch,
    itemperpage,
    params.pgno,
  ]);

  const viewfunction = (row) => {
    navigate(`/admin/reward-management/reward-config/view/${row._id}`);
  };

  const goToEdit = (row) => {
    navigate(
      `/admin/reward-management/reward-config/${params.pgno}/edit/${row._id}`,
    );
  };

  const ChangeStatus = (o_id, data) => {
    Swal.fire({
      customClass: "swal-wide",
      title: t(
        `Are you sure you want to ${data === 0 ? "deactivate" : "activate"} this Reward Config ?`,
      ),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes"),
    }).then((result) => {
      if (result.isConfirmed) {
        rewardConfigStatus({ o_id: o_id, status: data })
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error===>");
          });
      }
    });
  };

  function Deletefunction(id) {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes_delete"),
    }).then((result) => {
      if (result.isConfirmed) {
        rewardConfigDelete(id)
          .then((response) => {
            setStatusUpdate(!statsupdate);
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("deleteError");
          });
      }
    });
  }

  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };

  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    setSearch({});
    setResetDate(!resetdate);
    if ($("#defaultstatus")[0]) $("#defaultstatus")[0].selectedIndex = 0;
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">{t("Reward Configs")}</h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => setGlobalSearch(e.target.value)}
                    />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => prepareSearch("createdAt", e)}
                    resetdate={resetdate}
                  />
                </div>
                <div className="me-3">
                  <StatusFilter
                    data={showFilterlist}
                    prepareSearch={prepareSearch}
                  />
                </div>
                <button
                  type="reset"
                  onClick={resetFilter}
                  className="btn btn-warning float-right mr-2"
                >
                  {t("btn_reset_filter")}
                </button>
                <button
                  className="btn ripple btn-main-primary signbtn mr-2"
                  onClick={() =>
                    navigate(`/admin/reward-management/reward-config/add`)
                  }
                >
                  {t("Create New Reward Config")}
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                <thead>
                  <tr>
                    <th>{t("list_heading_sno")}</th>
                    <th>
                      <div className="sorting_column">
                        <span>{t("Title")}</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          column="title"
                        />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>{t("Type")}</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          column="type"
                        />
                      </div>
                    </th>
                    <th>{t("Reward Type")}</th>
                    <th>{t("Value")}</th>
                    <th>
                      <div className="sorting_column">
                        <span>{t("list_heading_created_date")}</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          defaultSorting={defaultSorting}
                          column="createdAt"
                        />
                      </div>
                    </th>
                    <th>{t("list_heading_status")}</th>
                    <th>{t("list_heading_action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={8}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {list.length ? (
                        list.map((row, i) => (
                          <tr key={i}>
                            <td>{(page - 1) * itemperpage + i + 1}</td>
                            <td>{row?.title || "N/A"}</td>
                            <td>
                              {row?.type === "level_completion"
                                ? "Level Completion"
                                : row?.type === "streak_bonus"
                                  ? "Streak Bonus"
                                  : row?.type === "milestone_achievement"
                                    ? "Milestone Achievement"
                                    : row?.type === "badge_definition"
                                      ? "Badge Definition"
                                      : row?.type}
                            </td>
                            <td>{row?.reward_type || "N/A"}</td>
                            <td>{row?.value || "N/A"}</td>
                            <td>
                              {row.createdAt
                                ? formateDateWithMonth(row.createdAt)
                                : "N/A"}
                            </td>
                            <td>
                              {row.is_active ? (
                                <button
                                  className="btn ripple btn-main-primary signbtn"
                                  onClick={() => ChangeStatus(row?._id, 0)}
                                >
                                  {t("btn_active")}
                                </button>
                              ) : (
                                <button
                                  className="btn ripple btn-secondary"
                                  onClick={() => ChangeStatus(row?._id, 1)}
                                >
                                  {t("btn_inactive")}
                                </button>
                              )}
                            </td>
                            <td>
                              <div className="d-flex">
                                <button
                                  className="btn ripple btn-main-primary signbtn"
                                  onClick={() => viewfunction(row)}
                                >
                                  {t("btn_view")}
                                </button>
                                <button
                                  className="btn ripple btn-success mlAction"
                                  onClick={() => goToEdit(row)}
                                >
                                  {t("btn_edit")}
                                </button>
                                <button
                                  className="btn ripple btn-secondary mlAction"
                                  onClick={() => Deletefunction(row?._id)}
                                >
                                  {t("btn_delete")}
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={8} className="text-center">
                            {t("msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
            <div id="example1_info" role="status" aria-live="polite">
              <b>
                {t("msg_total_records")} : {datalength || "0"}
              </b>
            </div>
            {datalength > 0 && (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                currentPage={page}
                setPage={setPage}
                pageRoute={[
                  {
                    name: "Reward Config List",
                    path: "/admin/reward-management/reward-config/list",
                  },
                ]}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default RewardConfigTable;
